import { createSlice } from '@reduxjs/toolkit';
export const entityCardSlice = createSlice({
  name: 'entity',
  initialState: {
    accordionKeyItems: [],
    openedAccordions: []
  },
  reducers: {
    pushEntityKeyData: (state, action) => {
      state.accordionKeyItems = action.payload;
    },
    pushOpenedAccordion: (state, action) => {
      state.openedAccordions.push(action.payload);
    },
    popClosedAccordion: (state, action) => {
      let existingOpenAccordions = [...state.openedAccordions];
      let remainingOpenAccordions = existingOpenAccordions.filter(accordion => accordion !== action.payload);
      state.openedAccordions = remainingOpenAccordions;
    },
    resetOpenedAccordions: state => {
      state.openedAccordions = [];
    },
    resetEntityCard: state => {
      state.accordionKeyItems = [], state.openedAccordions = [];
    }
  }
});
export const {
  pushEntityKeyData,
  pushOpenedAccordion,
  popClosedAccordion,
  resetOpenedAccordions,
  resetEntityCard
} = entityCardSlice.actions;
export default entityCardSlice.reducer;